<template>
  <div>
    <div class="d-flex">
      <v-btn icon @click="showDialog = true">
        <v-icon>mdi-camera</v-icon>
      </v-btn>
      <input
        type="file"
        accept="image/jpeg"
        id="photo-input"
        ref="photoInput"
        style="display: none"
        @change="onFileChange"
      />
      <CameraFileDialog
        :showDialog="showDialog"
        @takePhoto="onTakePhoto"
        @uploadFile="onUploadFile"
        @cancel="showDialog = false"
      />
    </div>
    <canvas
      v-if="imageSrc"
      id="full-size-canvas"
      :width="width"
      :height="height"
      hidden
    />
    <img
      v-if="imageSrc"
      :src="imageSrc"
      id="image-hidden"
      :style="{ width: imageWidth, height: imageHeight }"
      @load="setOriginalSize"
      hidden
    />
    <v-data-table
      :headers="headers"
      :items="records"
      item-key="photo_file_name"
      :sort-by="sortby"
      class="elevation-1"
      hide-default-footer
    ></v-data-table>
  </div>
</template>
<script>
import support from "../plugins/support";
import CameraFileDialog from "./CameraFileDialog.vue";

export default {
  name: "Photo-List",
  components: { CameraFileDialog },
  props: {
    records: Array,
  },
  data() {
    return {
      showDialog: false,
      selectedFile: [],
      handler: {},
      imageSrc: null,
      imageWidth: "auto",
      imageHeight: "auto",
      width: 1200, //assume landscape, flip if portrait
      height: 900,
      sortby: ["ts"],
      headers: [
        {
          value: "photo_file_name",
          text: "Photo Name",
        },
      ],
    };
  },
  methods: {
    onTakePhoto() {
      this.showDialog = false;
      this.$emit("cameraClicked");
    },
    onUploadFile() {
      this.showDialog = false;
      this.$nextTick(() => {
        this.$refs.photoInput.click();
      });
    },

    setOriginalSize(event) {
      // Set width and height to the original image size
      this.imageWidth = `${event.target.naturalWidth}px`;
      this.imageHeight = `${event.target.naturalHeight}px`;
      this.drawSmallerCanvas(event.target);
    },
    //photo handling functions in photolist are only for uploaded photos.
    async onFileChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        console.log(e);
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    drawSmallerCanvas(image) {
      const canvas = document.getElementById("full-size-canvas");
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (image.naturalWidth > image.naturalHeight) {
        canvas.width = this.width;
        canvas.height = this.height;
        ctx.drawImage(image, 0, 0, this.width, this.height);
      } else {
        canvas.width = this.height;
        canvas.height = this.width;
        ctx.drawImage(image, 0, 0, this.height, this.width);
      }

      // Use the shared compression logic to ensure file size is under 0.25 MB
      const compressedDataUrl = support.compressImage(canvas);

      this.photoData = compressedDataUrl.replace(
        "image/jpeg",
        "image/octet-stream"
      );

      this.$emit("photoAccepted", {
        photo_file_name: this.setFileName(),
        data: this.photoData.replace("data:image/octet-stream;base64,", ""),
      });
    },
    setFileName() {
      const d = new Date();
      return `${this.$store.getters["shared/dbName"]}_${
        this.$store.getters["shared/tabletCode"]
      }_${support
        .getLocalTimestamp(d)
        .replace(/ /g, "T")
        .replace(/:/g, "")}.jpeg`;
    },
    // downloadPhoto(obj) {
    //   const filename = obj.photo_file_name;
    //   // old skool DOM manipulation, not great...
    //   const link = document.createElement("a");
    //   link.style.display = "none";
    //   link.href = obj.data;
    //   link.download = filename;
    //   document.body.appendChild(link);
    //   link.click();
    //   setTimeout(() => {
    //     URL.revokeObjectURL(link.href);
    //     link.parentNode.removeChild(link);
    //   }, 0);
    // },
  },
};
</script>
<style scoped>
.flex {
  display: flex;
}
.centered-input input {
  text-align: center;
}
</style>
